export default "__VITE_ASSET__DvEvs7bh__"